import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";

export const DashboardSectionContainer = styled.div`
	padding: 4rem 8rem;
	max-width: 1800px;
	margin: auto;
`;

export const DashboardTitle = styled(Typography)`
	color: #545351;
	font-size: 1.2rem;
	margin-bottom: 1rem;
`;

export const DashboardContentContainer = styled.div`
	border: 2px solid #e0e0e0;
	background-color: #ffffff;
`;

export const DashboardLinkContainer = styled.div`
	margin-top: 28px;
	padding: 3rem 2rem;
	border: 2px solid #e0e0e0;
	background-color: #ffffff;
`;

export const GithubLinkContainer = styled.div`
	display: flex;
`;

export const FoodLensLinkContainer = styled.div`
	width: 50%;
	margin-right: 24px;
`;

export const CaloAILinkContainer = styled.div`
	width: 50%;
`;

export const GithubLinkTitle = styled.div`
	font-size: 20px;
	border-bottom: 2px solid #e1e5ea;
	padding-bottom: 9px;
	display: flex;
`;

export const GithubLinkContents = styled.div`
	padding: 20px 0px;
	font-size: 14px;
	color: #545351;
`;

export const DashboardDescription = styled.div`
	display: flex;
	justify-content: space-between;
	margin: 2rem 2rem 1rem 2rem;
`;

export const DashboardListOpenSpan = styled.span`
	color: #0071e3;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}
`;

export const CurrentModalContainer = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 1rem;
	margin-top: 1rem;
`;

export const DescriptionUpperTitleImage = styled.div`
	margin-right: 10px;
	width: 34px;
	height: 34px;
	padding: 5px;
	border-radius: 4px;
	background-color: #5292fa;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const CurrentModalText = styled.span`
	color: #545351;
	margin-right: 2rem;
	min-width: 8rem;
`;

export const DashboardLabelWapper = styled.div`
	display: flex;
	gap: 6px;
`;

export const DashboardLabel = styled.div`
	padding: 5px 10px;
	background-color: #f3f3f3;
	border-radius: 6.25rem;
`;

export const ExpireDateText = styled.span`
	color: #545351;
	margin-right: 4.8rem;
`;
export const ExpireDateValue = styled.span`
	color: red;
`;

export const ChargeManageButton = styled(Button)`
	border-color: #a9a9a9;
	height: 3.5rem;
`;

export const DashboardProgressBarContainer = styled.div`
	margin: 3rem 2rem;
`;

export const ProgressBarMountContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 1.5rem;
`;

export const ProgressBarMountTitle = styled.p`
	font-size: 16px;
	line-height: 28px;
	font-weight: bold;
`;

export const GuideLinkButton = styled(Button)`
	color: inherit;
	border-color: #7e7e7e;
	width: 120px;
	height: 30px;
	margin-right: 7px;
	align-self: center;
	text-transform: none;
	font-weight: bold;
`;

export const SkillDescriptionContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 0.5rem;
	font-size: 14px;
`;

export const SkillBarContainer = styled.div`
	width: 100%;
	height: 1rem;
	background-color: #e1e1e1;
`;

export const SkillValueBar = styled.div<{ value: string | number }>`
	width: ${(props) => props.value};
	height: 1rem;
	//background: linear-gradient(to right, rgb(0, 212, 255), rgb(97, 31, 105));
	background: linear-gradient(
			90deg,
			#fff838 0%,
			#f7993f 10.23%,
			#c2423b 17.23%,
			#200909 32.95%,
			#0b1429 49.05%,
			#172c58 71.78%,
			#3d7bf9 100%
		),
		#d9d9d9;
	display: flex;
	justify-content: flex-end;
`;

export const SkillValueText = styled.div`
	position: relative;
	top: 1.8rem;
	left: 1.5rem;
	display: inline-block;
	color: white;
	//background-color: #b121c8;
	background-color: #d91f15;
	border-radius: 6px;
	padding: 0.8rem 0.8rem;
	line-height: 0.3rem;
`;

export const SkillValuePointerCursor = styled.div<{ value: string | number }>`
	position: relative;
	left: ${(props) => props.value};
	bottom: 1rem;
	width: 2px;
	height: 1.2rem;
	background-color: #d91f15;
`;

export const SkillValuePointerDot = styled.div<{ value: string | number }>`
	position: relative;
	left: ${(props) => props.value};
	bottom: 1rem;
	width: 5px;
	height: 5px;
	border-radius: 100px;
	background-color: #d91f15;
`;
